import { render, staticRenderFns } from "./BaseNotice.vue?vue&type=template&id=42a87be8&"
import script from "./BaseNotice.vue?vue&type=script&lang=js&"
export * from "./BaseNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports